import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
// Component
import Avatar from '../Avatar';

// Locale
import messages from '../../locale/jsonMessages';
import StarRating from '../StarRating/StarRating';

import cs from '../commonStyle.css';
import s from './Reviews.css';

const ResponseItem = (props) => {

    const { data: { authorData: { firstName, lastName, profileId, picture } } } = props;
    const { data: { reviewContent, rating }, otherUserResponse, date, showReviewName } = props;
    const { formatMessage } = useIntl();

    return (
        <div>
            <div className={cs.commonlineCss}></div>
            <div className={cx(cs.reviewsContainer, s.responseFlex)}>
                <div className={cx(cs.reviewsYourItemsOne, s.pullLeft, 'floatRight')}>
                    <Avatar
                        source={picture}
                        title={firstName}
                        className={s.profileAvatar}
                        withLink
                        linkClassName={cx(s.avatarDisplay, cs.commonProfileAvatarLink)}
                        profileId={profileId}
                    />
                </div>
                <div className={cx(cs.reviewsYourItemsTwo, 'responseRs')}>
                    <span className={cx(cs.writtenReviewTitle, cs.commonContentText)}>{otherUserResponse ? firstName : (showReviewName ? firstName : formatMessage(messages.your))} <FormattedMessage {...messages.response} /></span>
                    {
                        reviewContent && <div className={cx(cs.reviewFlex, cs.dFlex, 'reviewStarSection')}>
                            <StarRating className='smallStarRatingAdjust' />
                            <div>{rating}</div>
                            <span className={cx(cs.dotCss)}></span>
                            <div className={cx(s.dateReviewCss, 'textWhite', 'dateReviewCssRTL')}>{date}</div>
                        </div>
                    }
                    <p className={cx(cs.reviewPara, cs.commonMediumText)}>
                        {
                            reviewContent
                        }
                    </p>
                </div>
            </div>
        </div>
    );
}

ResponseItem.propTypes = {
    data: PropTypes.shape({
        authorData: PropTypes.shape({
            picture: PropTypes.string,
            firstName: PropTypes.string,
            lastName: PropTypes.string,
            profileId: PropTypes.number,
        }),
    }),
    otherUserResponse: PropTypes.bool,
    formatMessage: PropTypes.any,
};

ResponseItem.defaultProps = {
    otherUserResponse: false,
};

export default withStyles(cs, s)(ResponseItem);